module.exports = __webpack_public_path__ + "static/media/Medusa.41558345.jpg";